import React from "react";

import { URLS } from "globalConstants";

import { LinkPill } from "./linkPill";

import { ReactComponent as FluteLogo } from "static/images/flute_logo.svg";

type AriseButtonProps = {
	isLoading: boolean;
	id: string;
	value?: string;
	baseUrl?: string;
};

export const AriseButton = ({
	isLoading = false,
	id,
	value = "Affiliate account",
	baseUrl = URLS.ariseAffiliate,
}: AriseButtonProps) => {
	const linkToArise = `${baseUrl}/${id}/info`;

	return (
		!isLoading && (
			<LinkPill icon={<FluteLogo />} label={value} href={linkToArise} />
		)
	);
};
